import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[connectorHost]',
    standalone: true,
})
export class ConnectorDirective {
  constructor(public viewContainerRef: ViewContainerRef){}
}